export default __webpack_public_path__ + "static/media/icon-file-green.4e231b3d.svg";